<span class="badge"
  [ngClass]="[
    'profile-' + profile.key,
    isCaptioned ? 'captioned' : '',
    isColored ? 'colored' : ''
  ]"
  [ngbTooltip]="isTooltipped && !isCaptioned ? 'Ladevorgang '+this.caption+'\: '+tooltip : isTooltipped ? tooltip : ''">
  <!-- *ngIf="profile.name != 'Standard'" -->

  <svg *ngIf="profile.key == 'now'"
    xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
    class="feather feather-zap">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    <!-- <polygon points="5 3 19 12 5 21 5 3"></polygon> -->
  </svg>

  <svg *ngIf="profile.key == 'minpv'"
    xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
    class="feather feather-leaf">
    <path d="M5.7,6.5C-0.7,13.2,6.3,19,6.3,19s7,3,11.2-1.6c4.2-4.2,3.4-13.9,3.4-13.9S9.8,2.4,5.7,6.5z"/>
    <path d="M5,22.6c0,0,0.2-2.9,0.6-5.2c0.5-3.2,3.3-6.2,8.4-7.5"/>
  </svg>

  <svg *ngIf="profile.key == 'pv'"
    xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
    class="feather feather-sun">
    <circle cx="12" cy="12" r="5"></circle>
    <line x1="12" y1="1" x2="12" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="23"></line>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
    <line x1="1" y1="12" x2="3" y2="12"></line>
    <line x1="21" y1="12" x2="23" y2="12"></line>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
  </svg>

  <!-- <span class="badge">•&ensp;•&ensp;•</span> -->
  <span class="caption">{{ caption }}</span>
</span>